import {
  ChangeEvent,
  DynamicContentType,
  Rounded,
  Shadow,
} from '@bm-js/atlascloud-shared'
import Select from './Select'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<{ rounded?: Rounded; shadow?: Shadow }>
  setData: (e: ChangeEvent) => void
}

const ImageOptions = ({ content, setData }: Props) => {
  const { tr } = useTr()

  return (
    <>
      <Select
        light
        label={tr(TrKey.imageOptionsRoundedLabel)}
        desc={tr(TrKey.imageOptionsRoundedDescription)}
        id='rounded'
        name='rounded'
        value={content.data.rounded}
        onChange={setData}
      >
        <option value='rounded-none'>
          {tr(TrKey.imageOptionsRoundedOptionNone)}
        </option>
        <option value='rounded-md'>
          {tr(TrKey.imageOptionsRoundedOptionMedium)}
        </option>
        <option value='rounded-xl'>
          {tr(TrKey.imageOptionsRoundedOptionXLarge)}
        </option>
      </Select>
      <Select
        light
        label={tr(TrKey.imageOptionsShadowLabel)}
        desc={tr(TrKey.imageOptionsShadowDescription)}
        id='shadow'
        name='shadow'
        value={content.data.shadow}
        onChange={setData}
      >
        <option value='shadow-none'>
          {tr(TrKey.imageOptionsShadowOptionNone)}
        </option>
        <option value='shadow-md'>
          {tr(TrKey.imageOptionsShadowOptionMedium)}
        </option>
        <option value='shadow-xl'>
          {tr(TrKey.imageOptionsShadowOptionXLarge)}
        </option>
      </Select>
    </>
  )
}

export default ImageOptions
